import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this a physical book?',
  a: "No. This is a digital product with instant access. You'll receive a download link immediately after purchase and can access all the recipes on any device."
}, {
  q: 'Are the recipes difficult to make?',
  a: "No. They're designed to be simple, practical and beginner-friendly. Most recipes take 30 minutes or less and use common ingredients you can find at any grocery store."
}, {
  q: 'Do I need expensive ingredients?',
  a: 'No. Most ingredients are easy to find in regular grocery stores. We focus on accessible, affordable ingredients that support thyroid health without breaking the bank.'
}, {
  q: 'When will I receive access?',
  a: "Immediately after completing your purchase. You'll receive an email with your login details and download links within minutes."
}, {
  q: 'Is this a subscription?',
  a: 'No. This is a one-time payment. You pay once and get lifetime access to all the recipes, bonuses, and any future updates we add.'
}, {
  q: 'Will this work if I have other dietary restrictions?',
  a: 'Many recipes include modifications for common dietary needs. Each recipe clearly lists ingredients so you can easily identify what works for you.'
}, {
  q: 'Do I need special kitchen equipment?',
  a: 'No. All recipes use standard kitchen equipment that most people already have. No expensive appliances or special tools required.'
}, {
  q: 'Can I print the recipes?',
  a: 'Yes! The PDF format is designed to be printer-friendly. You can print individual recipes or the entire cookbook if you prefer having a physical copy.'
}, {
  q: "What if I don't like it?",
  a: "We offer a 30-day money-back guarantee. If you're not satisfied for any reason, simply contact us within 30 days for a full refund."
}, {
  q: 'How is this different from free recipes online?',
  a: 'This is a complete system specifically designed for hypothyroidism, not random recipes. Everything is organized, tested, and includes meal planning tools to save you hours of research and guesswork.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 sm:py-12 px-4 bg-white" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-text-dark mb-8" data-id="element-41">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3" data-id="element-42">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-cream border border-brand-sage/30 rounded-lg overflow-hidden" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-brand-sage/5 transition-colors gap-4" data-id="element-44">
                <span className="font-bold text-brand-text-dark text-base" data-id="element-45">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-sage transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-46" />
              </button>

              {openIndex === i && <div className="px-5 pb-4 pt-0 text-brand-text-muted leading-relaxed" data-id="element-47">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}